import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'
import { Userspaces } from '@busy-human/opt-library'
import { storage, ref as sRef, uploadBytesResumable, getDownloadURL } from '../../util/firebase'
import { useUserspace } from '@/store/userspace';

type Props = {
    user: Userspaces.Model
}
type Emits = {
    (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'profile',
  props: {
    user: null
  },
  emits: ["close"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    user: Userspaces.Model
}





let userInitials = ref(((props.user?.name?.firstName?.[0] || '')+' '+(props.user?.name?.lastName?.[0] || '')).toUpperCase())

const imageURL = ref<string | undefined>()
let pictureUploaded = ref(false)

const fileInput = ref<HTMLInputElement>();

onMounted(()=> {
    if(props.user?.profilePic){
        imageURL.value = props.user.profilePic
        pictureUploaded.value = true
    }
})

let uploadValue = ref<number | null>(null)
const uploadFile = (e:any) => {
    const file = e.target.files[0]
    let uid = useUserspace().uid;
    if(file){
        const storageRef = sRef(storage, uid)
        const uploadTask = uploadBytesResumable(storageRef, file)
        uploadValue.value = 0;
        uploadTask.on('state_changed', snapshot => {
            uploadValue.value = Math.round((snapshot.bytesTransferred/snapshot.totalBytes)*100)
            // console.log("uploadValue", uploadValue.value)
            switch (snapshot.state) {
                case 'paused':
                    // console.log('Upload is paused');
                    break;
                case 'running':
                    // console.log('Upload is running');
                    break;
            }
        }, error => {
            console.log(error.message)
        }, () => {
            uploadValue.value = 100;
            getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                pictureUploaded.value = true
                uploadValue.value = null
                imageURL.value = url
                Userspaces.Collection.updateDoc(uid, {
                    profilePic: url
                })
                // console.log('File available at', imageURL.value);

            })
        })
    }else{
        // console.log("File Wasn't Uploaded")
    }
}

const __returned__ = { props, emit, userInitials, imageURL, pictureUploaded, fileInput, uploadValue, uploadFile, ref, onMounted, Userspaces, storage, sRef, uploadBytesResumable, getDownloadURL, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})